import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {UserContent} from 'app/profile/model/model';
import {ContentRepository} from '../repositories/content.repository';

@Injectable()
export class ContentService {

  constructor(private contentRepository: ContentRepository) { }

  public getContents(type:string): Observable<Array<UserContent>> {
    return this.contentRepository.getContents(type);
  }

  public getContent(userContent: UserContent): Observable<UserContent> {
    return this.contentRepository.getContent(userContent._id);
  }

  public getContentFlow(userContentId: string): Observable<UserContent> {
    return this.contentRepository.getContentFlow(userContentId);
  }

  public calculateNewContents(): Observable<number> {
    return this.contentRepository.calculateNewContents();
  }

  public start(userContent: UserContent): Observable<boolean> {
    return this.contentRepository.start(userContent._id);
  }

  public pause(userContent: UserContent): Observable<boolean> {
    return this.contentRepository.pause(userContent._id);
  }

  public resume(userContent: UserContent): Observable<boolean> {
    return this.contentRepository.resume(userContent._id);
  }

  public restart(userContent: UserContent): Observable<boolean> {
    return this.contentRepository.restart(userContent._id);
  }

  public purchase(userContent: UserContent, productId: string): Observable<boolean> {
    return this.contentRepository.purchase(userContent._id, productId);
  }

  public purchaseAbo(productId: string): Observable<boolean> {
    return this.contentRepository.purchase(null, productId);
  }

  public getPdf(userContentId: string, fileName: string, type = 'content'): Promise<string> {
    return this.contentRepository.getPdf(userContentId, fileName, type);
  }

}
